export default __webpack_public_path__ + "static/media/DB_8.b873810f.png";